import React, { useState } from "react";
import { Box, Chip, Link, Typography } from "@mui/material";
import currency from "currency.js";
import LineItemDetails from "./LineItemDetails";
import ImageCarousel from "../ImageCarousel";

export default function LineItemV2(props) {
  const { item } = props;

  const [showMore, setShowMore] = useState(Boolean(props.showMore));

  return (
    <Box sx={{ display: "flex", gap: "5px", minWidth: 0, width: "100%" }}>
      <Box sx={{ width: "40px", flexShrink: 0 }}>
        <ImageCarousel images={item.images} />
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0, overflow: "hidden" }}>
        <Typography variant="body1" noWrap>
          {item.title}
        </Typography>
        {props.view === "min" ? (
          <Box>
            <Link
              sx={{ cursor: "pointer", fontSize: ".9rem" }}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? "hide" : "show"} details
            </Link>
            {showMore && (
              <Box sx={{ borderLeft: "2px solid #ECECEC", paddingLeft: "1rem" }}>
                <LineItemDetails item={item} />
              </Box>
            )}
          </Box>
        ) : (
          <LineItemDetails item={item} />
        )}
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        <Chip size="small" label={item.quantity} sx={{ minWidth: "3rem" }} />
      </Box>
      <Box align="right" sx={{ minWidth: "4rem", flexShrink: 0 }}>
        <Typography variant="overline">{currency(item.total || item.price).format()}</Typography>
      </Box>
    </Box>
  );
}
